var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === 'ccvideo')?_c('Video',{staticStyle:{"width":"100%","height":"auto","margin":"0px auto"},attrs:{"video":_vm.data.content.id,"auto-play":true,"loop":true,"capture-img":_vm.data.content.imageUrl}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }